<template>
  <div class="box box__primary text-center box__header-title"
       v-bind:class="{
        'box__header-title-slim': $route.meta.slimHeader,
        'flex-1-div': ['sm'].includes($vuetify.breakpoint.name),
        'box__dark': $route.meta.type === 'professional',
        'box__light': $route.meta.type === 'contractor'
      }">
    <h2>Recuperação de senha</h2>
    <h4>Informe seu email para receber um link de<br v-if="!['xs'].includes($vuetify.breakpoint.name)">recuperação de senha</h4>
  </div>
</template>

<script>
export default {
  name: 'PasswordRecoveryHeader'
}
</script>
